import styled from "styled-components";

interface StyledIndicatorProps {
  thumbSize: number;
}

export default styled.div<StyledIndicatorProps>`
  color: #ffffff;
  font-weight: 400;
  font-size: ${({ thumbSize }) =>
    Math.round(Math.round(thumbSize * 0.4615) * 0.9565)}px;

  &:first-child > span {
    margin-left: -50%;
  }

  &:last-child > span {
    margin-left: 50%;
  }
`;
